import React from 'react';

export default function CrownSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Crown base */}
      <path d="M4 34L8 16L14 24L20 10L26 24L32 16L36 34Z" fill="#FFB300" />
      {/* Base rim */}
      <rect x="4" y="30" width="32" height="6" rx="1" fill="#FF8F00" />
      {/* Jewels */}
      <circle cx="14" cy="32" r="2" fill="#E53935" />
      <circle cx="20" cy="32" r="2" fill="#42A5F5" />
      <circle cx="26" cy="32" r="2" fill="#66BB6A" />
      {/* Point tips */}
      <circle cx="8" cy="16" r="2" fill="#FFD54F" />
      <circle cx="20" cy="10" r="2" fill="#FFD54F" />
      <circle cx="32" cy="16" r="2" fill="#FFD54F" />
    </svg>
  );
}
